import {
    Card,
    Input,
    Select,
    DateInput,
    Button,
    NumberInput,
    BaseTable,
    Loading,
} from "components"
import moment from "moment"
import { convertNumber, useHandleAuth, useLocation } from "utils"
import { CreateManagerModal } from "../components/CreateManagerModal"
import { useGestSingleSettingCompany } from "pages/Setup/Preference/SettingCompany/utils"
import { useProjectCode } from "../utils/useProjectCode"
import { useForm, Controller } from "react-hook-form"
import { FormStateProjectProfile } from "../types/ProfileTypes"
import { projectProfileSchema } from "../validation/ProjectProfileSchema"
import { yupResolver } from "@hookform/resolvers/yup"
import { useEffect } from "react"
import { getApprovalStatusLabel, PROJECT_TYPE_OPTIONS, PROJECT_STATUS_OPTIONS } from "../utils/projectTypeOption"
import { useEmployeeList } from "../utils/useEmployeeList"
import { useCustomerList } from "../utils/useCostumerList"
import { CreateCustomerModal } from "../components/CreateCustomerModal"
import { useDepartmentList } from "../utils/useDepartmentList"
import toast from "react-hot-toast"
import { useApi } from "utils"
import { useNavigate } from "react-router-dom"
import { useProfileDetail } from "../utils/useProfileDetail"
import { useTaskProgress } from "../utils/useTaskList"

interface TabProfileProps{
    action?:string
    project_id?:string
    setProjectCode:React.Dispatch<React.SetStateAction<string>>
    approval_view?:boolean
}
export function TabProfile(props:TabProfileProps): JSX.Element {
    const api = useApi()
    const navigate = useNavigate()
    const {data:dataCompany} = useGestSingleSettingCompany()
    const auth = useHandleAuth()
    const token = auth.userTokenData()
    const {code:projectCode} = useProjectCode(moment().format('YYYY-MM-DD'))
    const {isLoading:loadingEmployee, dropdown:dropdownEmployee, refetch:refetchEmployee } = useEmployeeList()
    const { isLoading:loadingSponsor, dropdown:dropdownSponsor, refetch:refetchSponsor } = useCustomerList()
    const { dataDepartment, isLoadingDepartment } = useDepartmentList()
    const { data , loading:isLoadingProfile } = useProfileDetail(props.project_id)
    const isDisabledForm = Boolean(props.action === 'view')
    const { data:dataLocation } = useLocation()
    const {countCompletedTask,
        countPendingTask,
        totalTask,
        progressTask,  
    } =  useTaskProgress(Number(props.project_id))


    const methods = useForm<FormStateProjectProfile>({
        resolver: yupResolver(projectProfileSchema),
        defaultValues: {
            project_name: '',
            trx_code: '',
            transaction_date: moment().format('YYYY-MM-DD'),
            status_project: 1,
            start_date: moment().format('YYYY-MM-DD'),
            due_date: moment().format('YYYY-MM-DD'),
            finished_date: !props.action ? null : moment().format('YYYY-MM-DD'),
            type_project: 0,
            type_project_id: 0,
            contact: '',
            approve_status: 1,
            location_id:'1',
            description: "",
            budget:null,
            actual_budget:null,
            over_budget:null
        },
    });

    const { handleSubmit, control, watch, setValue } = methods;
    const description = watch('project_name')
    useEffect(()=>{
        setValue('trx_code',projectCode)
        props.setProjectCode(projectCode ?? '')
        setValue('description', description)
        // eslint-disable-next-line
    },[projectCode,description])

    useEffect(() => {
        if (props.project_id && data?.length > 0) {
            const profile = data[0]; // karena payload array
            Object.entries(profile).forEach(([key, value]) => {
                if (value !== undefined) {
                    setValue(key as keyof FormStateProjectProfile, value);
                }
            });
        }
        props.setProjectCode(watch('trx_code') ?? '')
        // eslint-disable-next-line
    }, [props.project_id, data, setValue]);

    const startDate = watch("start_date");
    const dueDate = watch("due_date");
    const today = moment().toDate()
    // Hitung durasi (hari)
    const duration = startDate && dueDate ? moment(dueDate).diff(moment(startDate), "days") : 0;
    const dayBehind = watch('project_id')  && startDate ? moment(dueDate).diff(moment(today), "days") : 0;
    let weekBehind = watch('project_id')  && startDate ? moment(today).diff(moment(startDate), "days") : 0;
    weekBehind = Math.ceil(weekBehind / 7 );

    const onSubmit = (value: FormStateProjectProfile) => {
        return new Promise<void>((resolve) => {
            
            toast.promise(
                api.post("/project/save_project_profile", value),
                {
                    loading: "Loading...",
                    success: (res) => {
                        const projectId = res.data?.payload?.project_id;

                        if (projectId) {
                            navigate(`/project/edit/${projectId}`, { replace: true });
                        } 
                        return res.data.message
                    },
                    error: (err) => err.response.data.detail?.message ?? err.response.data.message
                }
            ).then(() => {
                // navigate("/project", { replace: true })
            }).catch(() => { }).finally(resolve)
      
        })
    }

    // handle semua error
    const onError = (errors: any) => {
        Object.values(errors).forEach((error: any) => {
            if (error?.message) {
                toast.error(error.message)
            } else if (typeof error === 'object') {
                Object.values(error).forEach((subError: any) => {
                    if (subError?.message) toast.error(subError.message)
                })
            }
        })
    };

    if(props.action && isLoadingProfile){
        return(
            <Loading 
                loading={isLoadingProfile}
            />
        )
    } 

    return (
        <section className="">
            <section>
                <Card>
                    <Card.Body>
                        <div className="flex flex-row w-full"> 
                            <div className="grow">
                                <div className="text-2xl font-bold uppercase py-4">
                                    {watch('project_name')}
                                </div>
                            </div>
                            <div className="flex gap-2">
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">DURATION | DAYS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{dayBehind}</span>
                                        <span className="text-sm">Leaf of days</span>
                                    </section>
                                </div>
                                <div className="min-h-[80px] flex flex-col border border-black">
                                    <div className="min-h-[40px] bg-black font-bold text-white text-sm text-center py-2 px-2">START | WEEKS</div>

                                    <section className="grow font-bold flex flex-col justify-center gap-1 p-3 text-center">
                                        <span className="text-lg">{weekBehind}</span>
                                        <span className="text-sm">Weeks</span>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </section>

        
            <section className="overflow-x-auto max-h-[calc(100vh-470px)] px-3 py-5">

                {/* BLOCK A */}
                <div className="flex lg:grid-cols-2 gap-[400px] justify-between">
                    <div className="w-full">
                        <div className="text-xl font-bold">{token?.company_name ?? '-'}</div>
                        <div className="space-y-2 mt-5">
                            <div className="flex items-center">
                                <div className="w-10 whitespace-nowrap">A :</div>
                                <div className="flex-1">
                                {dataCompany[0]?.address}
                                </div>
                            </div>
                            <div className="flex items-center">
                                <div className="w-10 whitespace-nowrap">E :</div>
                                <div className="flex-1">
                                    {dataCompany[0]?.email}
                                </div>
                            </div>
                            <div className="flex items-center">
                                <div className="w-10 whitespace-nowrap">T :</div>
                                <div className="flex-1">
                                {dataCompany[0]?.phone}
                                </div>
                            </div>
                            <div className="flex items-center">
                                <div className="w-10 whitespace-nowrap">W :</div>
                                <div className="flex-1">
                                    {dataCompany[0]?.website}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* block B */}
                    <div className="w-full">
        
                        <BaseTable className="min-w-full text-center">
                            <thead className="!bg-black !text-white">
                                <tr>
                                    <th>PROGRESS</th>
                                    <th>TOTAL</th>
                                    <th>COMPLETED</th>
                                    <th>PENDING</th>
                                    <th>OVERALL PROGRESS</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                    <th>MILESTONES</th>
                                    <td ></td>
                                    <td ></td>
                                    <td ></td>
                                    <td ></td>
                          
                                </tr>

                                <tr>
                                    <th>TASKS</th>
                                    <td >{convertNumber(totalTask).intoNormalAmount}</td>
                                    <td >{convertNumber(countCompletedTask).intoNormalAmount}</td>
                                    <td >{convertNumber(countPendingTask).intoNormalAmount}</td>
                                    <td >{progressTask}%</td>
                    
                                </tr>
                            </tbody>
                        </BaseTable>
    
                    </div>
                </div>

                {/* BLOCK C */}
                <div className="flex lg:grid-cols-2 gap-[400px] justify-between mt-[30px]">
                    <div className="w-full">
                        <div className="font-bold uppercase text-xl bg-gray-200 py-2 px-1">PROJECT DETAILS</div>
                        <hr />
                        <div className="space-y-2 mt-5">
                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">PROJECT NUMBER</div>
                                <div className="flex-1">
                                    <Controller
                                        name="trx_code"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <Input
                                                readOnly={true}
                                                disabled={isDisabledForm}
                                                value={field.value}
                                                onChange={(value) => {
                                                    field.onChange(value)
                                                }}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">PROJECT NAME</div>
                                <div className="flex-1">
                                    <Controller
                                        name="project_name"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <Input
                                                disabled={isDisabledForm}
                                                value={field.value}
                                                onChange={(value) => {
                                                    field.onChange(value)
                                                }}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">PROJECT TYPE</div>
                                <div className="flex-1">
                                    <Controller
                                        name="type_project"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <Select
                                                isDisabled={isDisabledForm}
                                                className="min-w-[150px]"
                                                value={
                                                    PROJECT_TYPE_OPTIONS.find(
                                                        (opt) => opt.value?.toString() === field.value.toString()
                                                    ) || PROJECT_TYPE_OPTIONS[0] // default ALL
                                                }
                                                options={PROJECT_TYPE_OPTIONS}
                                                onChange={(data) => {
                                                    field.onChange(data?.value)
                                                }}
                                                error={fieldState.error?.message}
                                            />
                                    )}/>
                                    
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">MANAGER</div>
                                <div className="flex flex-1">
                                    <Controller
                                        control={control}
                                        name="employee_id"
                                        render={({ field, fieldState }) => (
                                            <Select
                                                isDisabled={isDisabledForm}
                                                ref={field.ref}
                                                className="grow"
                                                placeholder="Select Manager"
                                                isLoading={loadingEmployee}
                                                options={dropdownEmployee ?? []}
                                                value={
                                                    field.value
                                                    ? dropdownEmployee.find(
                                                        (item) => item.value === field.value?.toString()
                                                    )
                                                    : null
                                                }
                                                onChange={(e) => field.onChange(e?.value)}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                    <div className="flex">
                                        <CreateManagerModal refetch={refetchEmployee}/>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">SPONSOR</div>
                                <div className="flex flex-1">
                                    <Controller
                                        control={control}
                                        name="customer_id"
                                        render={({ field, fieldState }) => (
                                            <Select
                                                isDisabled={isDisabledForm}
                                                ref={field.ref}
                                                className="grow"
                                                placeholder="Select Sponsor"
                                                isLoading={loadingSponsor}
                                                options={dropdownSponsor ?? []}
                                                value={
                                                    field.value
                                                    ? dropdownSponsor.find(
                                                        (item) => item.value === field.value?.toString()
                                                    )
                                                    : null
                                                }
                                                onChange={(e) => field.onChange(e?.value)}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                    <div className="flex">
                                        <CreateCustomerModal refetch={refetchSponsor}/>
                                    </div>
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">DEPARTEMENT</div>
                                <div className="flex-1">
                                    <Controller
                                        control={control}
                                        name="department_id"
                                        render={({ field, fieldState }) => (
                                            <Select
                                                isDisabled={isDisabledForm}
                                                ref={field.ref}
                                                className="grow"
                                                placeholder="Select Departement"
                                                isLoading={isLoadingDepartment}
                                                options={dataDepartment ?? []}
                                                value={
                                                    field.value
                                                    ? dataDepartment.find(
                                                        (item) => item.value === field.value?.toString()
                                                    )
                                                    : null
                                                }
                                                onChange={(e) => field.onChange(e?.value)}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">CONTACT</div>
                                <div className="flex-1">
                                    <Controller
                                        name="contact"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <Input
                                                disabled={isDisabledForm}
                                                value={field.value}
                                                onChange={(value) => {
                                                    field.onChange(value)
                                                }}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">LOCATION</div>
                                <div className="flex-1">
                                    <Controller
                                        control={control}
                                        name="location_id"
                                        render={({ field, fieldState }) => (
                                            <Select
                                                isDisabled={isDisabledForm}
                                                ref={field.ref}
                                                className="grow"
                                                placeholder="Select Location"
                                                isLoading={isLoadingDepartment}
                                                options={dataLocation ?? []}
                                                value={
                                                    field.value
                                                    ? dataLocation.find(
                                                        (item) => item.value === field.value?.toString()
                                                    )
                                                    : null
                                                }
                                                onChange={(e) => field.onChange(e?.value)}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                    {/* BLOCK D */}
                    <div className="w-full">
                        <div className="font-bold uppercase text-xl bg-gray-200 py-2 px-1">SCHEDULES</div>
                        <hr />
                        <div className="space-y-2 mt-5">
                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">START DATE</div>
                                <div className="flex-1">
                                    <Controller
                                        name="start_date"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <DateInput
                                                disabled={isDisabledForm}
                                                error={fieldState.error?.message}
                                                ref={field.ref}
                                                selected={moment(field.value).toDate()}
                                                onChange={(value) =>
                                                    field.onChange(moment(value).format("YYYY-MM-DD"))
                                                }
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">END DATE</div>
                                <div className="flex-1">
                                    <Controller
                                        name="due_date"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <DateInput
                                                disabled={isDisabledForm}
                                                error={fieldState.error?.message}
                                                ref={field.ref}
                                                selected={moment(field.value).toDate()}
                                                onChange={(value) =>
                                                    field.onChange(moment(value).format("YYYY-MM-DD"))
                                                }
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">FINISHED DATE</div>
                                <div className="flex-1">
                                    <Controller
                                        name="finished_date"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <DateInput
                                                disabled={isDisabledForm}
                                                error={fieldState.error?.message}
                                                ref={field.ref}
                                                selected={props.action === 'edit' || props.action === 'view' ? field.value ? moment(field.value).toDate() : null : null}
                                                onChange={(value) =>
                                                    field.onChange(moment(value).format("YYYY-MM-DD"))
                                                }
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">DURATION</div>
                                <div className="flex-1">
                                    <NumberInput
                                        disabled={isDisabledForm}
                                        value={duration}
                                        readOnly={true}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">REMAINING DAYS</div>
                                <div className="flex-1">
                                    <NumberInput
                                        disabled={isDisabledForm}
                                        className={dayBehind < 0 ? 'text-error':''}
                                        value={dayBehind}
                                        readOnly={true}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="flex lg:grid-cols-2 gap-[400px] justify-between mt-[30px] mb-[30px]">

                    {/* BLOCK E */}
                    <div className="w-full mt-5">
                        <div className="font-bold uppercase text-xl bg-gray-200 py-2 px-1">FINANCE</div>
                        <hr />
                        <div className="space-y-2 mt-5">
                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">BUDGET</div>
                                <div className="flex-1">
                                    <Controller
                                        name="budget"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <NumberInput
                                                readOnly
                                                textRight
                                                value={field.value}
                                                onValueChange={(value) => {
                                                    // if (value?.floatValue !== null || isNaN(value.floatValue) === false) {
                                                    //     field.onChange(value.floatValue)
                                                    // }
                                                    field.onChange(value.floatValue)
                                                }}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">ACTUAL SPEND</div>
                                <div className="flex-1">
                                    <Controller
                                        name="actual_budget"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <NumberInput
                                                readOnly
                                                textRight
                                                value={field.value}
                                                onValueChange={(value) => {
                                                    // if (value?.floatValue !== null || isNaN(value.floatValue) === false) {
                                                    //     field.onChange(value.floatValue)
                                                    // }
                                                    field.onChange(value.floatValue)
                                                }}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">OVER BUDGET</div>
                                <div className="flex-1">
                                    <Controller
                                        name="over_budget"
                                        control={control}
                                        render={({ field, fieldState }) => (
                                            <NumberInput
                                                className={`${field.value ?  field.value < 0 ? 'text-red-700':'' : ''}`}
                                                readOnly
                                                textRight
                                                value={field.value}
                                                onValueChange={(value) => {
                                                    // if (value?.floatValue !== null || isNaN(value.floatValue) === false) {
                                                    //     field.onChange(value.floatValue)
                                                    // }
                                                    field.onChange(value.floatValue)
                                                }}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* BLOCK F */}
                    <div className="w-full mt-5">
                        <div className="font-bold uppercase text-xl bg-gray-200 py-2 px-1">DOCUMENT CONTROL</div>
                        <hr />
                        <div className="space-y-2 mt-5">
                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">CREATE ON</div>
                                <div className="flex-1">
                                    <DateInput
                                        readOnly={true}
                                        disabled={isDisabledForm}
                                        selected={props.action === 'edit' || props.action === 'view' ? moment(watch('create_at')).toDate() : null}
                                        // value={field.value}
                                        onChange={(date) =>{
                                            console.log(date);                                      
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">LAST UPDATED ON</div>
                                <div className="flex-1">
                                    <DateInput
                                        readOnly={true}
                                        disabled={isDisabledForm}
                                        selected={props.action === 'edit' || props.action === 'view' ? watch('update_at') ? moment(watch('update_at')).toDate() : null : null}
                                        // value={undefined}
                                        onChange={(date) =>{
                                            console.log(date);                                      
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">UPDATED BY</div>
                                <div className="flex-1">
                                    <Input
                                        readOnly={true}
                                        value={
                                           watch('updated_by') ?? '-'
                                        }
                                        disabled={isDisabledForm}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">Approve</div>
                                <div className="flex-1">
                                    <Input
                                        disabled={isDisabledForm}
                                        value={getApprovalStatusLabel(watch('approve_status').toString())}
                                    />
                                </div>
                            </div>

                            <div className="flex items-center">
                                <div className="w-40 whitespace-nowrap">Status</div>
                                <div className="flex-1">
                                    {/* <Input
                                        disabled={isDisabledForm}
                                        value={getProjectStatusLabel(watch('status_project').toString())}
                                    /> */}

                                    <Controller
                                        control={control}
                                        name="department_id"
                                        render={({ field, fieldState }) => (
                                            <Select
                                                isDisabled={isDisabledForm}
                                                className="min-w-[150px]"
                                                value={
                                                    
                                                    (field.value) ? PROJECT_STATUS_OPTIONS.find(
                                                        (opt) => opt.value?.toString() === field.value.toString()
                                                    ) || PROJECT_STATUS_OPTIONS[0] :  PROJECT_STATUS_OPTIONS[0]// default ALL
                                                }
                                                options={PROJECT_STATUS_OPTIONS}
                                                onChange={(data) => {
                                                    field.onChange(data?.value)
                                                }}
                                                error={fieldState.error?.message}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="flex justify-end mt-[30px] mb-[30px]">
                    <Button color="primary" 
                        disabled={isDisabledForm}
                        className="min-w-[100px]"
                        type="button"
                        permission="ST19"
                        onClick={handleSubmit(onSubmit, onError)}
                    >
                        { props.action === 'edit' ? 'SAVE': 'CREATE'}
                    </Button>
                </div>

                

                {/* {(props.approval_view === true) ? (
                    <></>
                ):(
                    <FooterMenu
                        customRightElement={
                                <CommandButton
                                type="button"
                                actiontype="cancel"
                                onClick={() => {
                                    navigate("/project")
                                }}
                            />
                        }
                        customElement={{
                            journal:<></>,
                            print: <></>,
                        }}
                    />
                )}   */}
            </section>
        </section>
    )
}
